import React, { Component } from 'react';
import {
    Text,
    View,
} from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const maxTimes = 5;

class UpdatedNutrituonToast extends Component {
    constructor(props) {
      super(props);
      this.state = {
        times: 0
      };
    }
    componentDidMount() {
      this.intervalID = setInterval(() => this.tick(), 300);
    }
    componentWillUnmount() {
      clearInterval(this.intervalID);
    }
    tick() {
        if (maxTimes <= this.state.times) {
            this.props.timeReached();
            return;
        }  
        this.setState(prevState => {
            return {...prevState, times: prevState.times + 1}
        });
    }
    render() {
      return (
        <View style={{
            position: "absolute",
            zIndex: 1,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: 'center',
            alignItems: 'center',
        }}>
        <View style={{
            backgroundColor: Theme.CHARCOAL,
            opacity: 0.8,
            alignItems: 'center',
            justifyContent: 'center',
            width: defaultScale(200),
            height: defaultScale(30),
            }}>
            <Text style={{
                color: Theme.WHITE,
                fontWeight: 'bold',
                }}>{this.props.text}</Text>
        </View>
        </View>
      );
    }
}

export default UpdatedNutrituonToast;